import styled from 'styled-components';

export const TokenTierCardContainer = styled.div`
  align-items: center;
  aspect-ratio: 5 / 7;
  border-radius: 8px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: center;
  width: 300px;
  min-width: 300px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 123, 255, 0.15);
  }
  
  &.selected {
      background: rgba(255,255,255,0.2);
    border: 2px solid rgba(255,255,255,0.4);
  }
`;
export const CardContentContainer = styled.div`
  align-items: center;
  border-radius: 8px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 16px;
  justify-content: center;
  min-height: 0;
  padding: 16px;
  width: 100%;

  h2 {
    font-size: 16px;
    font-family: 'Inter', sans-serif;
    font-weight: 600;
    opacity: 0.4;
  }
`;
export const Price = styled.h1`
  font-family: 'Roboto', sans-serif;
  font-size: 48px;
  text-align: center;
`;
export const TokenRow = styled.div`
  display: flex;
  align-items: center;
`;
export const TokenImg = styled.img`
  width: 28px;
  height: 28px;
  margin-right: 0.6rem;
`;
export const TokenText = styled.h3`
  font-family: 'Roboto' sans-serif;
`;
export const BtnContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-shrink: 0;
  padding: 0;
  width: 100%;
`;